const items = [
  { text: "15 Spotless Rooms", gold: false },
  { text: "Gourmet Breakfasts & Dinners", gold: true },
  { text: "Full Service Bar", gold: false },
  { text: "Hindenburg Street", gold: true },
  { text: "Central Namibia Haven", gold: false },
];

export const Marquee = () => (
  <div
    data-testid="marquee-bar"
    className="border-b border-[#E3DFD5] bg-white py-4 overflow-hidden"
    aria-hidden="true"
  >
    <div className="mq-rail font-editorial text-base tracking-[0.2em] uppercase text-[#6B655B]">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`mx-6 ${item.gold ? "text-[#9E7D4E]" : ""}`}>{item.text}</span>
          <span className="text-[#C9C2B2]">✦</span>
        </span>
      ))}
    </div>
  </div>
);
